import React, {Component} from 'react';
import {
    AccountCampaignsConfiguration,
    METHOD_INCLUDE_ALL_CAMPAIGNS,
    METHOD_INCLUDE_CAMPAIGN_ON_CONDITION,
    METHOD_INCLUDE_ADGROUP_ON_CONDITION,
    METHOD_SELECT_ADGROUPS_FROM_LIST
} from "./AccountCampaignsConfiguration";
import {AccountActionsConfiguration} from "./AccountActionsConfiguration";
import {Alert, Card, CardBody, Collapse, Modal, ModalBody, ModalFooter, ModalHeader, Row} from 'reactstrap';
import {FacebookLogo} from "../../logos/FacebookLogo";
import {GoogleLogo} from "../../logos/GoogleLogo";
import {FaIcon} from "../../FaIcon";
import {YesNoModal} from "../../elements/YesNoModal";
import {SheetLogo} from "../../logos/SheetLogo";
import {TYPE_ONE_BUDGET_PER_ADGROUP, TYPE_ONE_BUDGET_PER_CAMPAIGN} from "../BusinessUnitTypes";
import {ANALYTICS_CHANNEL, CHANNEL_INFO_BY_CHANNEL} from "../../channels/channels";
import {Switch} from "../../buttons/Swtich";
import {TiktokLogo} from "../../logos/TiktokLogo";
import {LinkedinLogo} from "../../logos/LinkedinLogo";
import {ShopifyLogo} from "../../logos/ShopifyLogo";
import {TiendaNubeLogo} from "../../logos/TiendaNubeLogo";
import {WooCommerceLogo} from "../../logos/WooCommerceLogo";
import {VtexLogo} from "../../logos/VtexLogo";
import {AnalyticsLogo} from "../../logos/AnalyticsLogo";
import {Spinner} from "../../Spinner";
import {GA4PropertyCard} from "./GA4PropertyCard";
import {ShopifyAccountConfiguration} from "./ShopifyAccountConfiguration";
import {TiendaNubeAccountConfiguration} from "./TiendaNubeAccountConfiguration";
import {AnalyticsAccountConfiguration} from "./AnalyticsAccountConfiguration";
import {
    GA4FiltersEditor,
    FIELD_SOURCE as GA4_FIELD_SOURCE,
    FIELD_MEDIUM as GA4_FIELD_MEDIUM,
    FIELD_CAMPAIGN as GA4_FIELD_CAMPAIGN,
    FIELD_LANDING_PAGE as GA4_FIELD_LANDING_PAGE,
    FIELD_PRODUCT_NAME as GA4_FIELD_PRODUCT_NAME,
    FIELD_PRODUCT_ID as GA4_FIELD_PRODUCT_ID,
} from "./GA4FiltersEditor";
import {SHOPIFY_CHANNEL, TIENDA_NUBE_CHANNEL, WOOCOMMERCE_CHANNEL, VTEX_CHANNEL} from "../../channels/channels";
import { withTranslation } from 'react-i18next';

const GA4_IN_AD_ACCOUNT_AVAILABLE_FIELDS = [
    GA4_FIELD_SOURCE,
    GA4_FIELD_MEDIUM,
    GA4_FIELD_CAMPAIGN,
    GA4_FIELD_LANDING_PAGE,
    GA4_FIELD_PRODUCT_NAME,
    GA4_FIELD_PRODUCT_ID,
];


export const METHOD_ECOMMERCE_INCLUDE_ALL_CHANNELS_AND_TYPES = "ECOMMERCE_INCLUDE_ALL_CHANNELS_AND_TYPES";
export const METHOD_ECOMMERCE_SELECT_CHANNELS_AND_TYPES = "ECOMMERCE_SELECT_CHANNELS_AND_TYPES";
export const METHOD_ANALYTICS_INCLUDE_ALL_SOURCES_MEDIUMS = "INCLUDE_ALL_ANALYTICS_SOURCE_MEDIUM"
export const METHOD_ANALYTICS_INCLUDE_SOURCE_MEDIUM_ON_CONDITION = "INCLUDE_ANALYTICS_SOURCE_MEDIUM_ON_CONDITION"


class AccountClass extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: this.props.isOpen,
            confirmDeleteModalIsOpen: false,
            includeGA4Filters: this._hasGA4Configuration(this.props),
            configurationModalIsOpen: this.props.initialConfigurationModalOpen === true,
            configurationModalStep: 1,
            draftSelectedActions: this.props.initialConfigurationModalOpen === true
                ? (this.props.campaignsConfigurationData.selected_actions || [])
                : null
        };

        this.handleRolloverChange = this.handleRolloverChange.bind(this);
        this.handleActionsChange = this.handleActionsChange.bind(this);
        this.handleBudgetChange = this.handleBudgetChange.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.handleRefreshListItems = this.handleRefreshListItems.bind(this);
        this.handleGA4AccountChange = this.handleGA4AccountChange.bind(this);
        this.handleGA4FiltersChange = this.handleGA4FiltersChange.bind(this);
        this.handleGA4OverwriteConversionsChange = this.handleGA4OverwriteConversionsChange.bind(this);
        this.handleItemsSelectionMethodChange = this.handleItemsSelectionMethodChange.bind(this);
        this.handleItemBudgetChange = this.handleItemBudgetChange.bind((this));
        this.handleItemsSelectionChange = this.handleItemsSelectionChange.bind(this);
        this.handleIncludeTextChange = this.handleIncludeTextChange.bind(this);
        this.handleExcludeTextChange = this.handleExcludeTextChange.bind(this);
        this.handleWeekdayAlertChange = this.handleWeekdayAlertChange.bind(this);
        this.handleWorksOnWeekdayChange = this.handleWorksOnWeekdayChange.bind(this);
        this.toggle = this.toggle.bind(this);
        this.openConfirmDeleteModal = this.openConfirmDeleteModal.bind(this);
        this.handleDeleteAccount = this.handleDeleteAccount.bind(this);
        this.handleLoadInactiveCampaigns = this.handleLoadInactiveCampaigns.bind(this);
        this.handleLoadInactiveAdgroups = this.handleLoadInactiveAdgroups.bind(this);
        this.handleAnalyticsFiltersChange = this.handleAnalyticsFiltersChange.bind(this);
        this.handleIncludeGA4FiltersChange = this.handleIncludeGA4FiltersChange.bind(this);
        this.openConfigurationModal = this.openConfigurationModal.bind(this);
        this.handleOpenConfigurationModalClick = this.handleOpenConfigurationModalClick.bind(this);
        this.toggleConfigurationModal = this.toggleConfigurationModal.bind(this);
        this.goToPreviousConfigurationStep = this.goToPreviousConfigurationStep.bind(this);
        this.goToNextConfigurationStep = this.goToNextConfigurationStep.bind(this);
        this.handleDraftActionsChange = this.handleDraftActionsChange.bind(this);
        this.handleConfigurationModalFinish = this.handleConfigurationModalFinish.bind(this);
    }

    openConfirmDeleteModal() {
        this.setState({
            confirmDeleteModalIsOpen: true
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.initialConfigurationModalOpen === true && prevProps.initialConfigurationModalOpen !== true) {
            this.openConfigurationModal();
        }
    }

    toggle() {
        const isOpen = this.state.isOpen;
        this.setState({
            isOpen: !isOpen
        })
    }

    render() {
        return (
            <div className="section-body-item -wide box account-form">
                <header onClick={this.toggle} className="box-header ad-account">
                    <div className="header-title">
                        {this.platformLogo()}
                        <div className="account-header-copy">
                            <h2 className="box-title">
                                {this.renderTitle()}
                            </h2>
                            <span className="account-header-id">ID: {this.props.campaignsConfigurationData.platform_account_id}</span>
                        </div>
                    </div>
                    <div className="account-header-side">
                        {this.renderHeaderBudget()}
                        {this.renderRemoveAccountButton()}
                        {this.dropDownIcon()}
                    </div>
                </header>
                <Collapse isOpen={this.state.isOpen}>
                    <Card>
                        <CardBody>
                            {this.accountContent()}
                        </CardBody>
                    </Card>
                </Collapse>
                {this.renderConfigurationModal()}
            </div>
        )
    }

    platformLogo() {
        const logoProps = {height: 22, width: 22, hspace: 0, vspace: 0};

        if (this.props.campaignsConfigurationData.channel === 'FACEBOOK') {
            return <FacebookLogo {...logoProps}/>
        } else if (this.props.campaignsConfigurationData.channel === 'GOOGLE') {
            return <GoogleLogo useOld={true} {...logoProps}/>
        } else if (this.props.campaignsConfigurationData.channel === 'TIKTOK') {
            return <TiktokLogo {...logoProps}/>
        } else if (this.props.campaignsConfigurationData.channel === 'LINKEDIN') {
            return <LinkedinLogo {...logoProps}/>
        } else if (this.props.campaignsConfigurationData.channel === SHOPIFY_CHANNEL) {
            return <ShopifyLogo {...logoProps}/>
        } else if (this.props.campaignsConfigurationData.channel === TIENDA_NUBE_CHANNEL) {
            return <TiendaNubeLogo {...logoProps}/>
        } else if (this.props.campaignsConfigurationData.channel === WOOCOMMERCE_CHANNEL) {
            return <WooCommerceLogo {...logoProps}/>
        } else if (this.props.campaignsConfigurationData.channel === VTEX_CHANNEL) {
            return <VtexLogo {...logoProps}/>
        } else if (this.props.campaignsConfigurationData.channel === ANALYTICS_CHANNEL) {
            return <AnalyticsLogo {...logoProps}/>
        } else {
            return <SheetLogo {...logoProps}/>
        }
    }

    dropDownIcon() {
        return <FaIcon className="dropdown-arrow" iconName="chevron-down"/>
    }

    renderTitle() {
        return this.props.campaignsConfigurationData.name;
    }

    renderHeaderBudget() {
        const {t} = this.props;
        return (
            <div className="account-header-budget">
                <span>{t('budget_config.allocated_budget')}</span>
                <strong>{this.getBudgetValueReadOnlyText()}</strong>
            </div>
        );
    }

    renderRemoveAccountButton() {
        return (
            <span className="account-header-remove" onClick={event => event.stopPropagation()}>
                <YesNoModal onYesAnswer={this.handleDeleteAccount} title={this.props.t('account.delete_config_title')}
                            message={this.props.t('account.delete_config_message')}
                            question={this.props.t('account.delete_config_question')}
                            buttonClassName={"account-remove-icon-button"}
                            buttonText={""}
                            buttonTitle={this.props.t('account.remove_button')}
                            buttonIconName={"trash"}
                />
            </span>
        );
    }

    getBudgetValueReadOnlyText() {
        const amount = this.props.campaignsConfigurationData.allocated_budget;
        const formattedValue = amount !== null && amount !== undefined && amount !== ''
            ? Number(amount).toLocaleString('en-US')
            : '-';

        if (this.props.canEditCurrency) {
            return `${this.props.campaignsConfigurationData.budget_currency}$ ${formattedValue}`;
        }
        return `$ ${formattedValue}`;
    }

    renderNoAccessMessage() {
        const { t } = this.props;
        return <div className="col-12"><Alert className="alert-warning filtering-alert">{t('account.no_access')}</Alert></div>
    }

    renderStillDoingFirstSyncing() {
        const { t } = this.props;
        return <div className="col-12"><Alert className="alert-warning filtering-alert">{t('account.first_sync')}</Alert></div>
    }

    accountContent() {
        let innerContent = null;
        if (!this.props.campaignsConfigurationData.ad_account_has_connection)
            innerContent = this.renderNoAccessMessage();
        else if(this.props.campaignsConfigurationData.last_entities_update_on === null)
            innerContent = this.renderStillDoingFirstSyncing();
        else if (this.props.campaignsConfigurationData.channel === SHOPIFY_CHANNEL)
            innerContent = this.renderShopifyContent();
        else if (this.props.campaignsConfigurationData.channel === TIENDA_NUBE_CHANNEL)
            innerContent = this.renderTiendaNubeContent();
        else if (this.props.campaignsConfigurationData.channel === WOOCOMMERCE_CHANNEL)
            innerContent = this.renderWooCommerceContent();
        else if (this.props.campaignsConfigurationData.channel === VTEX_CHANNEL)
            innerContent = this.renderVtexContent();
        else if (this.props.campaignsConfigurationData.channel === ANALYTICS_CHANNEL)
            innerContent = this.renderAnalyticsContent();
        else
            innerContent = this.renderRegularAccountContent()

        return (
            <Row>
                {innerContent}
            </Row>
        )
    }

    renderShopifyContent() {
        return (
            <div className="col-12">
                <ShopifyAccountConfiguration
                    adAccountId={this.props.campaignsConfigurationData.ad_account_id}
                    storeId={this.props.campaignsConfigurationData.platform_account_id}
                    selectionMethod={this.props.campaignsConfigurationData.selection_method}
                    selectedChannelsAndTypes={this.props.campaignsConfigurationData.selected_channels_and_types || []}
                    onItemsSelectionMethodChange={this.handleItemsSelectionMethodChange}
                    onItemsSelectionChange={this.handleShopifyChannelsAndTypesChange}
                />
            </div>
        );
    }

    renderTiendaNubeContent() {
        return (
            <div className="col-12">
                <TiendaNubeAccountConfiguration
                    adAccountId={this.props.campaignsConfigurationData.ad_account_id}
                    storeId={this.props.campaignsConfigurationData.platform_account_id}
                    selectionMethod={this.props.campaignsConfigurationData.selection_method}
                    selectedChannelsAndTypes={this.props.campaignsConfigurationData.selected_channels_and_types || []}
                    onItemsSelectionMethodChange={this.handleItemsSelectionMethodChange}
                    onItemsSelectionChange={this.handleTiendaNubeChannelsAndTypesChange}
                />
            </div>
        );
    }

    renderWooCommerceContent() {
        return (
            <div className="col-12">
                <div className="section-toggle" style={{ padding: '5px' }}>
                    <a style={{ color: '#B6B6B7', textDecoration: 'none', cursor: 'default' }}>
                        {this.props.t('account.woocommerce_all_traffic_included')}
                    </a>
                </div>
            </div>
        );
    }

    renderVtexContent() {
        return (
            <div className="col-12">
                <div className="section-toggle" style={{ padding: '5px' }}>
                    <a style={{ color: '#B6B6B7', textDecoration: 'none', cursor: 'default' }}>
                        {this.props.t('account.vtex_all_traffic_included')}
                    </a>
                </div>
            </div>
        );
    }

    handleShopifyChannelsAndTypesChange(selectedChannelsAndTypes) {
        if (this.props.onItemsSelectionChange) {
            this.props.onItemsSelectionChange(selectedChannelsAndTypes, null, this.props.configId);
        }
    }

    handleTiendaNubeChannelsAndTypesChange(selectedChannelsAndTypes) {
        if (this.props.onItemsSelectionChange) {
            this.props.onItemsSelectionChange(selectedChannelsAndTypes, null, this.props.configId);
        }
    }

    renderAnalyticsContent() {
        return (
            <div className="col-12">
                <AnalyticsAccountConfiguration
                    selectionMethod={this.props.campaignsConfigurationData.selection_method}
                    ga4Filters={this.props.campaignsConfigurationData.ga4_filters || []}
                    onItemsSelectionMethodChange={this.handleItemsSelectionMethodChange}
                    onFiltersChange={this.handleAnalyticsFiltersChange}
                />
            </div>
        );
    }

    handleAnalyticsFiltersChange(filters) {
        this.props.onAnalyticsFiltersChange(filters, this.props.configId);
    }

    renderRegularAccountContent() {
        return this.renderInnerInputs();
    }

    renderInnerInputs() {
        const {t} = this.props;
        const buttonText = this.hasCampaignsConfiguration()
            ? t('agency_subscription.edit')
            : t('account_setup.add_campaigns');

        return (
            <div className="col-12 account-setup-flow">
                <div className="account-summary-header">
                    <div>
                        <h3>{t('account_setup.configuration_summary_title')}</h3>
                        <p>{t('account_setup.configuration_summary_description')}</p>
                    </div>
                    <button type="button" className="account-setup-edit-button" onClick={this.handleOpenConfigurationModalClick}>
                        <FaIcon iconName={this.hasCampaignsConfiguration() ? "pencil-alt" : "plus"}/>
                        {buttonText}
                    </button>
                </div>
                <div className="account-summary-grid">
                    {this.renderCampaignsSummaryCard()}
                    {this.renderGA4SummaryCard()}
                    {this.renderConversionsSummaryCard()}
                </div>
                {/*202207: Se comenta porque en el refactoring de chauBU holra Presu esto debería pasar al BU pero
                        por lo que vemos, ninguna agencia activa usa esta funcionalidad en ningun cliente.
                        Por ahora escondemos el front pero queda to.do el codigo en front y back
                    */}
                {/*<DaysOfTheWeekBoleans*/}
                {/*    name={"works_on_weekday"}*/}
                {/*    label={"Las campañas funcionan sólo los días:"}*/}
                {/*    onWeekdayChange={this.handleWorksOnWeekdayChange}*/}
                {/*    monday={this.props.campaignsConfigurationData.works_on_weekday_monday}*/}
                {/*    tuesday={this.props.campaignsConfigurationData.works_on_weekday_tuesday}*/}
                {/*    wednesday={this.props.campaignsConfigurationData.works_on_weekday_wednesday}*/}
                {/*    thursday={this.props.campaignsConfigurationData.works_on_weekday_thursday}*/}
                {/*    friday={this.props.campaignsConfigurationData.works_on_weekday_friday}*/}
                {/*    saturday={this.props.campaignsConfigurationData.works_on_weekday_saturday}*/}
                {/*    sunday={this.props.campaignsConfigurationData.works_on_weekday_sunday}*/}
                {/*/>*/}
            </div>
        );
    }

    renderCampaignsSummaryCard() {
        const {t} = this.props;
        const items = this.getSelectedCampaignSummaryItems();

        return (
            <article className="account-summary-card">
                <div className="account-summary-card-header">
                    <h4>{t('account_setup.campaigns_summary_title')}</h4>
                </div>
                <p>{this.getCampaignsSummaryDescription(items.length)}</p>
                {this.renderSummaryPills(items, t('account_setup.no_campaigns_selected_short'))}
            </article>
        );
    }

    renderGA4SummaryCard() {
        const {t} = this.props;
        return (
            <article className="account-summary-card">
                <div className="account-summary-card-header">
                    <h4>{t('account_setup.ga4_summary_title')}</h4>
                </div>
                <p>{this.renderGA4SummaryText()}</p>
            </article>
        );
    }

    renderConversionsSummaryCard() {
        if (!this.accountChannelHasActions()) {
            return null;
        }

        const {t} = this.props;
        const selectedActionLabels = this.getSelectedActionLabels();

        return (
            <article className="account-summary-card">
                <div className="account-summary-card-header">
                    <h4>{t('account_setup.conversions_summary_title')}</h4>
                </div>
                <p>{t('account_setup.step_events_description')}</p>
                {selectedActionLabels === null
                    ? <Spinner color="positive"/>
                    : this.renderSummaryPills(selectedActionLabels, t('account_setup.no_events_selected'))}
            </article>
        );
    }

    renderSummaryPills(items, emptyText) {
        if (items.length === 0) {
            return <div className="account-events-empty">{emptyText}</div>;
        }

        return (
            <div className="account-events-summary">
                {items.map(item => (
                    <span key={item.id} className="account-event-pill">{item.name}</span>
                ))}
            </div>
        );
    }

    getCampaignsSummaryDescription(itemsCount) {
        const {t} = this.props;
        const method = this.props.campaignsConfigurationData.selection_method;

        if (method === METHOD_INCLUDE_ALL_CAMPAIGNS) {
            return t('account_setup.include_all_active_campaigns');
        }

        if (method === METHOD_SELECT_ADGROUPS_FROM_LIST) {
            return t('account_setup.selected_adgroups_count', {count: itemsCount});
        }

        if (method === METHOD_INCLUDE_CAMPAIGN_ON_CONDITION) {
            return t('account_setup.automatic_campaigns_summary');
        }

        if (method === METHOD_INCLUDE_ADGROUP_ON_CONDITION) {
            return t('account_setup.automatic_adgroups_summary');
        }

        return t('account_setup.selected_campaigns_count', {count: itemsCount});
    }

    getSelectedCampaignSummaryItems() {
        const data = this.props.campaignsConfigurationData;
        const method = data.selection_method;

        if (method === METHOD_INCLUDE_ALL_CAMPAIGNS) {
            return (data.all_active_account_campaigns || [])
                .filter(item => item.is_active)
                .map(item => ({id: item.id, name: item.name}));
        }

        if (method === METHOD_SELECT_ADGROUPS_FROM_LIST) {
            const selectedAdgroups = data.selected_adgroups || [];
            return this.getAdgroupsData()
                .filter(item => selectedAdgroups.includes(item.id.toString()))
                .map(item => ({id: item.id, name: this.getItemSummaryName(item)}));
        }

        if (method === METHOD_INCLUDE_CAMPAIGN_ON_CONDITION || method === METHOD_INCLUDE_ADGROUP_ON_CONDITION) {
            return this.getConditionSummaryItems();
        }

        const selectedCampaigns = data.selected_campaigns || [];
        return this.getCampaignsData()
            .filter(item => selectedCampaigns.includes(item.id.toString()))
            .map(item => ({id: item.id, name: item.name}));
    }

    getConditionSummaryItems() {
        const {t} = this.props;
        const data = this.props.campaignsConfigurationData;
        const items = [];

        if (data.include_containing) {
            items.push({
                id: 'include-condition',
                name: `${t('account_setup.condition_include')}: ${data.include_containing}`
            });
        }

        if (data.exclude_containing) {
            items.push({
                id: 'exclude-condition',
                name: `${t('account_setup.condition_exclude')}: ${data.exclude_containing}`
            });
        }

        return items;
    }

    getCampaignsData() {
        const data = this.props.campaignsConfigurationData;
        if (data.all_not_active_campaigns === null || data.all_not_active_campaigns === undefined) {
            return [...(data.all_active_account_campaigns || []), ...(data.some_selected_not_active_campaigns_data || [])];
        }
        return [...(data.all_active_account_campaigns || []), ...(data.all_not_active_campaigns || [])];
    }

    getAdgroupsData() {
        const data = this.props.campaignsConfigurationData;
        if (data.all_not_active_adgroups === null || data.all_not_active_adgroups === undefined) {
            return [...(data.all_active_account_adgroups || []), ...(data.some_selected_not_active_adgroups_data || [])];
        }
        return [...(data.all_active_account_adgroups || []), ...(data.all_not_active_adgroups || [])];
    }

    getItemSummaryName(item) {
        if (item.campaign_name === undefined) {
            return item.name;
        }
        return `${item.campaign_name} - ${item.name}`;
    }

    hasCampaignsConfiguration() {
        const data = this.props.campaignsConfigurationData;
        const method = data.selection_method;

        if (method === METHOD_INCLUDE_ALL_CAMPAIGNS) {
            return true;
        }

        if (method === METHOD_SELECT_ADGROUPS_FROM_LIST) {
            return (data.selected_adgroups || []).length > 0;
        }

        if (method === METHOD_INCLUDE_CAMPAIGN_ON_CONDITION || method === METHOD_INCLUDE_ADGROUP_ON_CONDITION) {
            return Boolean(data.include_containing || data.exclude_containing);
        }

        return (data.selected_campaigns || []).length > 0;
    }

    renderCampaignSelectionConfiguration() {
        return (
            <AccountCampaignsConfiguration
                onAccountChange={this.handleAccountChange}
                budgetPerItemModeOn={(this.props.businessUnitType === TYPE_ONE_BUDGET_PER_CAMPAIGN || this.props.businessUnitType === TYPE_ONE_BUDGET_PER_ADGROUP)}
                allocatedBudgetByItem={this.props.businessUnitType === TYPE_ONE_BUDGET_PER_CAMPAIGN ? this.props.campaignsConfigurationData.budget_by_campaign_id : this.props.campaignsConfigurationData.budget_by_adgroup_id}
                onItemBudgetChange={this.handleItemBudgetChange}
                onSelectionMethodChange={this.handleItemsSelectionMethodChange}
                onItemsSelectionChange={this.handleItemsSelectionChange}
                onIncludeTextChange={this.handleIncludeTextChange}
                onExcludeTextChange={this.handleExcludeTextChange}
                itemChannel={this.props.campaignsConfigurationData.channel}
                selectedAccountId={this.props.campaignsConfigurationData.ad_account_id}
                selectedPlatformAccountId={this.props.campaignsConfigurationData.platform_account_id}
                adAccountHasConnection={this.props.campaignsConfigurationData.ad_account_has_connection}
                campaignsSelectionMethod={this.props.campaignsConfigurationData.selection_method}
                onlyMethodSelectCampaignsFromList={(this.props.businessUnitType === TYPE_ONE_BUDGET_PER_CAMPAIGN)}
                onlyMethodSelectAdgroupsFromList={(this.props.businessUnitType === TYPE_ONE_BUDGET_PER_ADGROUP)}
                conditionIncludeText={this.props.campaignsConfigurationData.include_containing}
                conditionExcludeText={this.props.campaignsConfigurationData.exclude_containing}
                lastEntitiesUpdatedOn={this.props.campaignsConfigurationData.last_entities_update_on}
                allActiveCampaigns={this.props.campaignsConfigurationData.all_active_account_campaigns}
                allActiveAdgroups={this.props.campaignsConfigurationData.all_active_account_adgroups}
                allNotActiveCampaigns={this.props.campaignsConfigurationData.all_not_active_campaigns}
                allNotActiveAdgroups={this.props.campaignsConfigurationData.all_not_active_adgroups}
                selectedCampaigns={this.props.campaignsConfigurationData.selected_campaigns}
                selectedAdgroups={this.props.campaignsConfigurationData.selected_adgroups}
                someSelectedNotActiveCampaignsData={this.props.campaignsConfigurationData.some_selected_not_active_campaigns_data}
                someSelectedNotActiveAdgroupsData={this.props.campaignsConfigurationData.some_selected_not_active_adgroups_data}
                budgetCurrency={this.props.campaignsConfigurationData.budget_currency}
                canEditCurrency={this.props.canEditCurrency}
                selectionMethodsAllowed={this.props.selectionMethodsAllowed}
                onRefreshListItems={this.handleRefreshListItems}
                isUpdatingListItems={this.props.isUpdatingListItems}
                messageForRefreshListItemsIconToolbox={this.props.messageForRefreshListItemsIconToolbox}
                onLoadInactiveCampaigns={this.handleLoadInactiveCampaigns}
                onLoadInactiveAdgroups={this.handleLoadInactiveAdgroups}
                isLoadingInactiveItems={this.props.isLoadingInactiveItems}
            />
        );
    }

    renderSetupStep(number, title, description, action, content, extraClassName = '') {
        return (
            <section className={`account-setup-step ${extraClassName}`}>
                <div className="account-setup-step-header">
                    <span className="account-setup-step-number">{number}</span>
                    <div className="account-setup-step-copy">
                        <h3>{title}</h3>
                        {description && <p>{description}</p>}
                    </div>
                    {action && <div className="account-setup-step-action">{action}</div>}
                </div>
                {content && <div className="account-setup-step-body">{content}</div>}
            </section>
        );
    }

    renderGA4Section() {
        let elements = [
            <p key="description" className="account-setup-step-description">
                {this.props.t('account_setup.step_ga4_body_description')}
            </p>
        ];

        if(!this.ga4IsEnabled()) {
            const { t } = this.props;
            elements.push(<div className="alert alert-info">{t('account.ga4_consult_team')}</div>);
            return elements;
        }

        elements = elements.concat([
            <div key="account" className="form-row">
                <label>{this.props.t('account.property')}</label>
                <GA4PropertyCard
                    selectedAccount={this.props.campaignsConfigurationData.ga4_ad_account_account_id}
                    allAccounts={this._getFormattedAllGA4Accounts()}
                    onAccountChange={this.handleGA4AccountChange}
                    addLinkToConnectOption={!this.props.ga4IsConnected}
                />
            </div>,
            <div key="ga4_filters" className="form-row">
                {this._hasGA4PropertySelected()
                    ? <GA4FiltersEditor
                        filters={this.props.campaignsConfigurationData.ga4_filters || []}
                        availableFields={GA4_IN_AD_ACCOUNT_AVAILABLE_FIELDS}
                        onChange={this.handleGA4FiltersChange}
                    />
                    : <div className="ga4-filters-editor-disabled">
                        {this.props.t('ga4_filters.requires_property_hint')}
                    </div>
                }
            </div>
        ]);

        if (this.props.campaignsConfigurationData.ga4_agency_can_overwrite === true) {
            elements.push(
                <div className="row">
                    <div key="overwrite" className="form-row switch-input p-3"
                        style={{ paddingTop: "0", borderBottom: "0" }}>
                        <label>{this.props.t('account.ga4_overwrite_label')}</label>
                        <Switch onChange={this.handleGA4OverwriteConversionsChange}
                            checked={this.props.campaignsConfigurationData.ga4_overwrite_purchase_value_and_convertions}
                            name="ga4_overwrite_purchase_value_and_convertions" />
                    </div>
                </div>
            );
        }

        return elements;
    }

    renderGA4SummaryText() {
        const {t} = this.props;
        if (!this.state.includeGA4Filters) {
            return t('account_setup.step_ga4_disabled');
        }
        if (this._hasGA4PropertySelected()) {
            return t('account_setup.step_ga4_configured');
        }
        return t('account_setup.step_ga4_enabled');
    }

    _hasGA4PropertySelected() {
        const accountId = this.props.campaignsConfigurationData.ga4_ad_account_account_id;
        return accountId !== null && accountId !== undefined && accountId !== '';
    }

    _getFormattedAllGA4Accounts() {
        if (this.props.allGA4Accounts === undefined || this.props.allGA4Accounts === null)
            return [];

        return this.props.allGA4Accounts.map(account => ({ 'id': account.account_id, 'name': account.name, 'has_access': (account.error_found === null || account.error_found === undefined) }));
    }

    ga4IsEnabled() {
        return this.props.ga4IsEnabled;
    }

    getSelectedActionLabels() {
        const {t} = this.props;
        const channelInfo = CHANNEL_INFO_BY_CHANNEL[this.props.campaignsConfigurationData.channel];
        const selectedActions = this.props.campaignsConfigurationData.selected_actions || [];
        const allActions = this.props.campaignsConfigurationData.all_actions;

        if (selectedActions.length === 0 && channelInfo["hasIncludeAllConversionsSetting"]) {
            return [{id: 'all-primary-conversions', name: t('actions_multi_select.all_primary_conversions')}];
        }

        if (allActions === null || allActions === undefined) {
            return null;
        }

        return selectedActions.map(actionId => {
            const action = allActions.find(item => {
                const itemId = item.action_id != null ? item.action_id.toString() : null;
                return itemId === actionId.toString();
            });
            return {
                id: actionId,
                name: action ? action.description : actionId
            };
        });
    }

    renderConfigurationModal() {
        const {t} = this.props;
        const isLastStep = this.state.configurationModalStep === this.getConfigurationStepsCount();

        return (
            <Modal
                isOpen={this.state.configurationModalIsOpen}
                toggle={this.toggleConfigurationModal}
                className="account-configuration-modal"
                modalClassName="account-configuration-modal-window"
                wrapClassName="account-configuration-modal-shell"
                backdropClassName="account-configuration-modal-backdrop"
                zIndex={2300}
            >
                <ModalHeader toggle={this.toggleConfigurationModal}>{t('account_setup.configuration_modal_title')}</ModalHeader>
                <ModalBody>
                    <div className="modal-section account-configuration-modal-body">
                        {this.renderConfigurationStepIndicator()}
                        {this.renderConfigurationModalStepContent()}
                    </div>
                </ModalBody>
                <ModalFooter className="account-configuration-modal-footer">
                    <button type="button" className="account-flow-button -cancel" onClick={this.toggleConfigurationModal}>
                        {t('ga4_property.cancel')}
                    </button>
                    <div className="account-configuration-modal-footer-actions">
                        {this.state.configurationModalStep > 1 && (
                            <button type="button" className="account-flow-button -ghost" onClick={this.goToPreviousConfigurationStep}>
                                <FaIcon iconName="arrow-left"/>
                                {t('account_setup.back')}
                            </button>
                        )}
                        {isLastStep ? (
                            <button type="button" className="account-flow-button -primary" onClick={this.handleConfigurationModalFinish}>
                                {t('account_setup.finish')}
                            </button>
                        ) : (
                            <button type="button" className="account-flow-button -primary" onClick={this.goToNextConfigurationStep}>
                                {t('account_setup.next')}
                                <FaIcon iconName="arrow-right"/>
                            </button>
                        )}
                    </div>
                </ModalFooter>
            </Modal>
        );
    }

    renderConfigurationStepIndicator() {
        const steps = this.getConfigurationSteps();

        return (
            <div className="account-configuration-steps">
                {steps.map(step => (
                    <button
                        type="button"
                        key={step.number}
                        className={this.state.configurationModalStep === step.number ? '-active' : ''}
                        onClick={() => this.setState({configurationModalStep: step.number})}
                    >
                        <span>{step.number}</span>
                        {step.title}
                    </button>
                ))}
            </div>
        );
    }

    renderConfigurationModalStepContent() {
        const {t} = this.props;

        if (this.state.configurationModalStep === 1) {
            return this.renderSetupStep(
                1,
                t('account_setup.step_campaigns_title'),
                t('account_setup.step_campaigns_description'),
                null,
                this.renderCampaignSelectionConfiguration(),
                '-modal-step'
            );
        }

        if (this.state.configurationModalStep === 2) {
            return this.renderSetupStep(
                2,
                t('account_setup.step_ga4_title'),
                this.renderGA4SummaryText(),
                this.renderGA4Toggle(),
                this.state.includeGA4Filters ? this.renderGA4Section() : null,
                '-modal-step'
            );
        }

        return this.renderSetupStep(
            3,
            t('account_setup.step_events_title'),
            t('account_setup.step_events_description'),
            null,
            this.renderActionsConfiguration(),
            '-modal-step'
        );
    }

    renderGA4Toggle() {
        const {t} = this.props;
        return (
            <div className="account-setup-switch">
                <Switch
                    name="include_ga4_filters"
                    checked={this.state.includeGA4Filters}
                    onChange={this.handleIncludeGA4FiltersChange}
                    style={{margin: 0}}
                />
                <span>{t('account_setup.include_ga4_filters')}</span>
            </div>
        );
    }

    renderActionsConfiguration() {
        if (!this.accountChannelHasActions()) {
            return null;
        }

        const draftSelectedActions = this.state.draftSelectedActions !== null
            ? this.state.draftSelectedActions
            : (this.props.campaignsConfigurationData.selected_actions || []);

        return (
            <AccountActionsConfiguration
                selectedActions={draftSelectedActions}
                allActions={this.props.campaignsConfigurationData.all_actions}
                onChange={this.handleDraftActionsChange}
                hasIncludeAllConversionsSetting={CHANNEL_INFO_BY_CHANNEL[this.props.campaignsConfigurationData.channel]["hasIncludeAllConversionsSetting"]}
                channel={this.props.campaignsConfigurationData.channel}
                onRefreshListItems={this.handleRefreshListItems}
                isUpdatingListItems={this.props.isUpdatingListItems}
                messageForRefreshListItemsIconToolbox={this.props.messageForRefreshListItemsIconToolbox}
            />
        );
    }

    getConfigurationSteps() {
        const {t} = this.props;
        const steps = [
            {number: 1, title: t('account_setup.step_campaigns_short')},
            {number: 2, title: t('account_setup.step_ga4_short')}
        ];

        if (this.accountChannelHasActions()) {
            steps.push({number: 3, title: t('account_setup.step_events_short')});
        }

        return steps;
    }

    getConfigurationStepsCount() {
        return this.getConfigurationSteps().length;
    }

    accountChannelHasActions() {
        const channelInfo = CHANNEL_INFO_BY_CHANNEL[this.props.campaignsConfigurationData.channel];
        return channelInfo && channelInfo["hasActions"];
    }

    _hasGA4Configuration(props) {
        const data = props.campaignsConfigurationData || {};
        const hasProperty = data.ga4_ad_account_account_id !== null && data.ga4_ad_account_account_id !== undefined && data.ga4_ad_account_account_id !== '';
        const hasFilters = Array.isArray(data.ga4_filters) && data.ga4_filters.length > 0;
        const hasOverwrite = data.ga4_overwrite_purchase_value_and_convertions === true;
        return hasProperty || hasFilters || hasOverwrite;
    }

    handleRolloverChange(value) {
        this.props.onRolloverChange(value, this.props.configId)
    }

    handleItemBudgetChange(allocatedBudgetByItemId, selectedCampaigns, selectedAdgroups) {
        this.props.onItemBudgetChange(this.props.configId, allocatedBudgetByItemId, selectedCampaigns, selectedAdgroups);
    }

    handleActionsChange(selectedActions) {
        this.props.onActionsChange(selectedActions, this.props.configId)
    }

    handleIncludeGA4FiltersChange(event) {
        this.setState({includeGA4Filters: event.target.checked});
    }

    openConfigurationModal() {
        this.setState({
            configurationModalIsOpen: true,
            configurationModalStep: 1,
            draftSelectedActions: this.props.campaignsConfigurationData.selected_actions || []
        });
    }

    handleOpenConfigurationModalClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.openConfigurationModal();
    }

    toggleConfigurationModal() {
        this.setState(prevState => ({
            configurationModalIsOpen: !prevState.configurationModalIsOpen,
            configurationModalStep: 1,
            draftSelectedActions: prevState.configurationModalIsOpen ? null : prevState.draftSelectedActions
        }));
    }

    goToPreviousConfigurationStep() {
        this.setState(prevState => ({
            configurationModalStep: Math.max(1, prevState.configurationModalStep - 1)
        }));
    }

    goToNextConfigurationStep() {
        this.setState(prevState => ({
            configurationModalStep: Math.min(this.getConfigurationStepsCount(), prevState.configurationModalStep + 1)
        }));
    }

    handleDraftActionsChange(selectedActions) {
        this.setState({draftSelectedActions: selectedActions});
    }

    handleConfigurationModalFinish() {
        if (this.accountChannelHasActions()) {
            this.props.onActionsChange(this.state.draftSelectedActions || [], this.props.configId);
        }
        this.setState({
            configurationModalIsOpen: false,
            configurationModalStep: 1,
            draftSelectedActions: null
        });
    }

    handleBudgetChange(newCurrency, newBudget) {
        this.props.onBudgetChange(newCurrency, newBudget, this.props.configId)
    }

    handleAccountChange(adAccountId, accountName) {
        this.props.onAccountChange(adAccountId, accountName, this.props.configId)
    }

    handleRefreshListItems() {
        this.props.onRefreshItemsList(this.props.configId);
    }

    handleLoadInactiveCampaigns() {
        this.props.onLoadInactiveCampaigns(this.props.configId);
    }

    handleLoadInactiveAdgroups() {
        this.props.onLoadInactiveAdgroups(this.props.configId);
    }

    handleGA4AccountChange(ga4AdAccountId, ga4AccountName) {
        this.props.onGA4AccountChange(ga4AdAccountId, ga4AccountName, this.props.configId)
    }

    handleGA4FiltersChange(filters) {
        this.props.onGA4FiltersChange(filters, this.props.configId)
    }

    handleGA4OverwriteConversionsChange(event) {
        this.props.onGA4OverwriteConversionsChange(event.target.checked, this.props.configId)
    }

    handleItemsSelectionMethodChange(newValue) {
        this.props.onItemsSelectionMethodChange(newValue, this.props.configId)
    }

    handleItemsSelectionChange(itemsSelected, allocatedBudgetByItemId) {
        this.props.onItemsSelectionChange(itemsSelected, allocatedBudgetByItemId, this.props.configId)
    }

    handleIncludeTextChange(newText, allocatedBudgetByItemId) {
        this.props.onIncludeTextChange(newText, allocatedBudgetByItemId, this.props.configId)
    }

    handleExcludeTextChange(newText, allocatedBudgetByItemId) {
        this.props.onExcludeTextChange(newText, allocatedBudgetByItemId, this.props.configId)
    }

    handleWorksOnWeekdayChange(name, value) {
        this.props.onWorksOnWeekdayChange(name, value, this.props.configId)
    }

    handleWeekdayAlertChange(name, value) {
        this.props.onWeekdayAlertChange(name, value, this.props.configId)
    }

    handleDeleteAccount() {
        this.props.onDeleteAccount(this.props.configId)
    }
}

export const Account = withTranslation()(AccountClass);
